import React from 'react'
import Footer from './Footer'

const Column2 = () => {
  return (
    <div className="coluna2">
      <div className="parte-superior">      
      </div>
      <div className="parte-inferior">       
      </div>
      <Footer/>   
    </div>
  )
}

export default Column2


// WEBPACK FOOTER //
// ./src/Column2.js